import LazyObserver from '../components/img-lazy-load';
import MagnificPopup from '../components/magnific-popup';
import Front from "../components/front";

export default {
  init() {
    // JavaScript to be fired on all pages
    LazyObserver.init();
    Front.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// WEBPACK FOOTER //
// assets/js/routes/common.js